import { render, staticRenderFns } from "./idpPeriod.vue?vue&type=template&id=470b1f55"
import script from "./idpPeriod.vue?vue&type=script&lang=js"
export * from "./idpPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports